/* eslint-disable @typescript-eslint/no-unused-vars */
import '~/i18n/init'

// Third Party Libs
import 'jquery-ui-bundle'
import 'bootstrap'
import 'flatpickr'
import angular from 'angular'
import ngSanitize from 'angular-sanitize'
import 'angular-animate'
import ngTagsInput from 'ng-tags-input'
import ui, { sortable } from 'angular-ui-sortable'
import 'angular-ui-bootstrap'
import toastr from 'angular-toastr'
import 'angular-drag-and-drop-lists'
import 'jquery.caret'
import moment from 'moment-timezone'
import 'angular-moment'
import { get } from 'lodash'
/* eslint-enable no-unused-vars */

// global stuff
import '../services/index'
import '../routes/index'
import '~/redux'

// smart "container" components
import '../btnSelect/index'
import '../dateQuickPicker/index'
import '../picklist/index'
import '../root/index'
import '../search/index'
import '../settings/index'
import '../story/index'
import '../noAccess/index'
import '../storyNotFound/index'
import '../storyAccessDenied/index'

// angular editions
// import '../angularPerformance/index'
import '../contenteditablebind/index' // fixes ngModel bindings
import '../calendarControl/index' // add calendar plugin
import '../codeEditor/index' // add codemirror plugin
import '../tooltipControl/index'
import '../sortable/index' // adds drag & drop sortablejs plugin

// modals
import '../modal/index'

// dumb "presentational" components
import '../authorSelection/index'
import '../canonicalUrl/index'
import '../channelToggles/index'
import '../clipboard/index'
import '../composeBody/index'
import '../contentElement/index'
import '../contentComment/index'
import '../contentTools/index'
import '../deleteModal/index'
import '../filters/index'
import '../findReplace/index'
import '../headline/index'
import '../imageFocalPoint/index'
import '../kicker/index'
import '../kickerAdmin/index'
import '../linkMenu/index'
import '../lockKnockButtons/index'
import '../metaBody/index'
import '../metaElement/index'
import '../navActions/index'
import '../navHeader/index'
import '../overlay/index'
import '../pitchCard/index'
import '../planningBody/index'
import '../promoBody/index'
import '../propertyPane/index'
import '../publishActions/index'
import '../relatedItems/index'
import '../revisions/index'
import '../searchFilters/index'
import '../searchResults/index'
import '../orgSettingsJson/index'
import '../distributor/index'
import '../storyTags/index'
import '../storyToolbar/index'
import '../workflowBar/index'
import '../tabBar/index'
import '../tansa/index'
import '../toolbox/index'
import '../typographyButtons/index'
import '../webskedPitches/index'
import '../webskedTasks/index'
import '../wskTaskCard/index'
import '../timePicker'
import '../quickTimePicker'
import '../snowball/index'
import '../lockless/index'
import '../planning/index'
import '../authorization/index'
import '../errors/index'
import '../validation/index'
import '../beats/index'
import '../line-configuration'
import '../linklistsubtypes-configuration'
import '../proofreader-settings'
import '../stateful-lock-actions'
import '../publishDate/index'
import '../revision-history-locking'
import '../primary-website-field'

import '../directives/momentDateFormatter'
import '../uiStateManager/index'
import '../directives/pasteOptions'
import '../directives/quotePropEditor'
import '../directives/draftEditor'
import '../directives/webskedButtons'
import '../directives/ratingPropEditor'
import '../directives/settingsSiteSelector'
import '../directives/mediaPicker'
import '../directives/featuredMediaSettings'
import '../directives/featured-media-custom-embed'

export const APP = 'ellipsisApp'

// annotate everything
export const dependencies = [
  // vendor
  'ui.bootstrap',
  'ui.sortable',
  'ngSanitize',
  'ngTagsInput',
  'ngAnimate',
  'toastr',
  'dndLists',
  'angularMoment',

  // globals
  'ellipsis.services',
  'ellipsis.routes',
  'ellipsis.filters',

  // containers
  'ellipsis.authorSelection',
  'ellipsis.canonicalUrl',
  'ellipsis.btnSelect',
  'ellipsis.dateQuickPicker',
  'ellipsis.overlay',
  'ellipsis.picklist',
  'ellipsis.root',
  'ellipsis.search',
  'ellipsis.settings',
  'ellipsis.distributor',
  'ellipsis.story',
  'ellipsis.noaccess',
  'ellipsis.storyNotFound',
  'ellipsis.storyAccessDenied',
  'ellipsis.publishDate',

  // modals
  'ellipsis.modal',

  // redux
  'ellipsis.redux',

  // components
  // 'ellipsis.angularPerformance',
  'ellipsis.elTooltip',
  'ellipsis.elSortable',
  'ellipsis.calendarControl',
  'ellipsis.channelToggles',
  'ellipsis.clipboard',
  'ellipsis.codeEditor',
  'ellipsis.composeBody',
  'ellipsis.contentComment',
  'ellipsis.contenteditablebind',
  'ellipsis.contentElement',
  'ellipsis.contentTools',
  'ellipsis.dateQuickPicker',
  'ellipsis.deleteModal',
  'ellipsis.findReplace',
  'ellipsis.headline',
  'ellipsis.kicker',
  'ellipsis.kickerAdmin',
  'ellipsis.linkMenu',
  'ellipsis.lockKnockButtons',
  'ellipsis.metaBody',
  'ellipsis.metaElement',
  'ellipsis.navActions',
  'ellipsis.navHeader',
  'ellipsis.pitchCard',
  'ellipsis.planningBody',
  'ellipsis.promoBody',
  'ellipsis.propertyPane',
  'ellipsis.publishActions',
  'ellipsis.relatedItems',
  'ellipsis.revisions',
  'ellipsis.searchFilters',
  'ellipsis.searchResults',
  'ellipsis.orgSettingsJson',
  'ellipsis.storyTags',
  'ellipsis.storyToolbar',
  'ellipsis.workflowBar',
  'ellipsis.tabBar',
  'ellipsis.tansa',
  'ellipsis.toolbox',
  'ellipsis.typographyButtons',
  'ellipsis.webskedPitches',
  'ellipsis.webskedTasks',
  'ellipsis.webskedButtons',
  'ellipsis.wskTaskCard',
  'ellipsis.imageFocalPoint',
  'ellipsis.storyToolbar',
  'ellipsis.momentDateFormatter',
  'ellipsis.uiStateManager',
  'ellipsis.pasteOptions',
  'ellipsis.quotePropertyEditor',
  'ellipsis.draftEditor',
  'ellipsis.timePicker',
  'ellipsis.quickTimePicker',
  'ellipsis.ratingPropertyEditor',
  'ellipsis.snowball',
  'ellipsis.lockless',
  'ellipsis.planning',
  'ellipsis.authorization',
  'ellipsis.errors',
  'ellipsis.validation',
  'ellipsis.beats',
  'ellipsis.settingsSiteSelector',
  'ellipsis.mediaPicker',
  'ellipsis.featuredMediaSettings',
  'ellipsis.featuredMediaCustomEmbed',
  'ellipsis.lineConfiguration',
  'ellipsis.linkListSubtypesConfiguration',
  'ellipsis.proofreaderSettings',
  'ellipsis.statefulLockActions',
  'ellipsis.revisionHistoryLocking',
  'ellipsis.primaryWebsiteField',
]

export default angular
  .module(APP, dependencies)
  .constant('uibDropdownConfig', {
    appendToOpenClass: 'uib-dropdown-open',
    openClass: 'show', // Fix for bootstrap 4
  })
  .constant('moment', moment)
  .config([
    '$httpProvider',
    ($httpProvider) => {
      $httpProvider.interceptors.push('httpInterceptorService')
    },
  ])
  .controller('ellipsisController', [
    '$scope',
    '$rootScope',
    '$location',
    function ($scope, $rootScope, $location) {
      // log app verison
      console.info('Arc Composer Version:', process.env.COMPOSER_VERSION)

      $scope.isDraftApp = false
      $rootScope.$on('$locationChangeStart', (e, _newUrl, oldUrl) => {
        if (oldUrl.includes('/ellipsis/')) {
          $location.url(oldUrl.split('/ellipsis')[1].replace('/#!', ''))
        }
      })
      $rootScope.$on('$routeChangeStart', (e, current) => {
        $scope.isDraftApp = get(current, '$$route.isDraftApp', false)
      })
    },
  ])
